import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const SymbolB2CIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-symbol-b2c"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      d="M23.5443 8.57531L17.1865 0.751638C16.7281 0.188621 16.0043 -0.0882254 15.2865 0.024962L5.32109 1.61084C4.60342 1.7256 4.00147 2.21369 3.74172 2.89146L0.134072 12.301C-0.125272 12.9788 -0.00306705 13.7433 0.454719 14.3068L6.81247 22.1379C7.27279 22.6987 7.99709 22.9727 8.71398 22.8572L18.6794 21.2698C19.3971 21.1562 19.9994 20.6684 20.2588 19.9907L23.8664 10.5811C24.1253 9.90304 24.0026 9.13856 23.5443 8.57531Z"
      fill="url(#paint0_linear_15916_70802)"
    />
    <path
      d="M14.7511 6.74673L12.4946 10.7777L10.2769 5.99176L7.50742 6.72886L4.07874 15.6545H7.13756L9.20163 10.3905L11.2344 15.4043H12.8003L15.8084 10.0302V16.9053L18.6629 15.9419V7.44064L14.7511 6.74673Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_15916_70802"
        x1="9.91205"
        y1="24.2753"
        x2="22.618"
        y2="12.675"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00044188" stopColor="#0397A7" />
        <stop offset="0.9971" stopColor="#00ECCD" />
      </linearGradient>
    </defs>
  </Svg>
));

SymbolB2CIcon.displayName = 'SymbolB2CIcon';
